import { useTranslations } from 'next-intl';
import GuestCard from '../commons/GuestCard';
import UserCorks from '../commons/UserCorks';

interface Props {
  isAuth: boolean;
  loyaltyPoints: number;
}

const UserInfo = (props: Props): JSX.Element => {
  const t = useTranslations('loyalty');

  if (props.isAuth && props.loyaltyPoints != null) {
    return (
      <div className="tw-container tw-mx-auto tw-flex tw-flex-1 tw-items-center tw-justify-center">
        <UserCorks corks={props.loyaltyPoints} />
      </div>
    );
  }

  let errorContent: JSX.Element = (
    <div className="tw-p-2 md:tw-p-4 tw-text-center">
      {t('wallet.shop.fetchCorkError')}
    </div>
  );

  if (!props.isAuth) {
    errorContent = <GuestCard />;
  }

  return (
    <section className="tw-container tw-mx-auto tw-px-4 lg:tw-px-6 xl:tw-px-8">
      {errorContent}
    </section>
  );
};

export default UserInfo;
